<script>

export let color;
export let toggleModal;

let w;

</script>

<style type="text/sass">

.wrap
  // position: absolute
  // bottom: 0
  height: 55px
  background: #fff
  width: 100vw
  box-sizing: border-box
  border-top: 1px solid #08141F
  color: #08141F
  font-size: 17px

.flex-c
  display: flex
  align-items: center
  justify-content: center

span
  line-height: 45px
  flex: 1
  display: inline-block
  text-align: center

h4
  font-size: 18px
  letter-spacing: 0.04em
  cursor: pointer
  user-select: none
  border-bottom: none

.socials

  &:hover svg
    opacity: 0.7
    transform: scale(0.95)

  a
    margin-left: 3px
    margin-right: 3px

    &:last-child
      margin-left: -3px
      margin-right: -3px

  svg
    margin-bottom: -6px
    transition-duration: 0.3s

    &:hover
      opacity: 1
      transform: scale(1.05)


@media (max-width: 550px)


  .title
    max-width: 0

  h4
    display: none

  .socials
    padding-right: 2em
    text-align: right

  .logo
    margin-left: -2em


</style>

<div bind:clientWidth={w} class="wrap flex-c">

  <span class="logo">
    <a target="_blank" href="https://kuacoffee.co/">
      <svg fill={color} style="margin-top: 15px" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 211 76"><title>Logo_Flag</title><path d="M37.79 20.85h23.47L41.53 42.4l20.24 31.87H38.9L27.67 56l-7 6.78v11.53H.56V.82h20.13v40.47zM113.67 74.27l-1.32-8.09a23.59 23.59 0 01-19 9.3c-12.65 0-18.62-7.38-18.62-20V20.85h20.14V53c0 4.45 2.33 7.59 6.78 7.59a8.19 8.19 0 008.4-8.4V20.85h20.13v53.42h-16.51zM203.31 37v20.88c0 2.22 1 3.94 3.23 3.94h3.65v11.64s-3.75 2-10.53 2c-8.09 0-13-2.63-14.87-6.67-4.45 3.54-10.42 6.67-19.73 6.67-11.13 0-18.82-3.84-18.82-15 0-16 13.56-19 36.93-19v-2.6c0-4.35-3.44-6.38-7.79-6.38-3.54 0-7.69 1.12-7.69 4.66v.4h-19.83a6.7 6.7 0 01-.1-1.41c0-9.82 9.61-16.5 27.92-16.5 14.68 0 27.63 4.25 27.63 17.37zm-36.93 20.88c0 4.15 3.44 5.06 6.88 5.06 5.16 0 9.91-3 9.91-7.39V51c-11.94 0-16.79 2.93-16.79 6.88z"/></svg>
    </a>
  </span>

  <span class="title">
    <h4 on:click={toggleModal} >
      Happy Days Project
    </h4>
  </span>

  <span class="socials">
    {#if w > 550} Share {/if}
    <a target="_blank" href="https://twitter.com/share?text=Kua%27s+Happy+Days+Project+is+awesome&url=https://hdp.kuacoffee.co/&via=kuacoffeeau">
      <svg version="1.2" baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 20"><path d="M18.89 7.012c.808-.496 1.343-1.173 1.605-2.034-.786.417-1.569.703-2.351.861-.703-.756-1.593-1.14-2.66-1.14-1.043 0-1.924.366-2.643 1.078-.715.717-1.076 1.588-1.076 2.605 0 .309.039.585.117.819-3.076-.105-5.622-1.381-7.628-3.837-.34.601-.51 1.213-.51 1.846 0 1.301.549 2.332 1.645 3.089-.625-.053-1.176-.211-1.645-.47 0 .929.273 1.705.82 2.388.549.676 1.254 1.107 2.115 1.291-.312.08-.641.118-.979.118-.312 0-.533-.026-.664-.083.23.757.664 1.371 1.291 1.841.625.472 1.344.721 2.152.743-1.332 1.045-2.855 1.562-4.578 1.562-.422 0-.721-.006-.902-.038 1.697 1.102 3.586 1.649 5.676 1.649 2.139 0 4.029-.542 5.674-1.626 1.645-1.078 2.859-2.408 3.639-3.974.784-1.564 1.172-3.192 1.172-4.892v-.468c.758-.57 1.371-1.212 1.84-1.921-.68.293-1.383.492-2.11.593z"/></svg>
    </a>
    <a target="_blank" href='https://www.linkedin.com/shareArticle?mini=true&url=https://kuacoffee.co&title=Happy+Days+Project&summary=Talking+about+world+positive+business'>
      <svg version="1.2" baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="2 1 20 20"><path d="M8 19h-3v-10h3v10zm11 0h-3v-5.342c0-1.392-.496-2.085-1.479-2.085-.779 0-1.273.388-1.521 1.165v6.262h-3s.04-9 0-10h2.368l.183 2h.062c.615-1 1.598-1.678 2.946-1.678 1.025 0 1.854.285 2.487 1.001.637.717.954 1.679.954 3.03v5.647z"/><ellipse cx="6.5" cy="6.5" rx="1.55" ry="1.5"/></svg>
    </a>
    <a target="_blank" href='https://www.facebook.com/sharer/sharer.php?u=https://hdp.kuacoffee.co/'>
      <svg version="1.2" baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 21"><path d="M13 10h3v3h-3v7h-3v-7h-3v-3h3v-1.255c0-1.189.374-2.691 1.118-3.512.744-.823 1.673-1.233 2.786-1.233h2.096v3h-2.1c-.498 0-.9.402-.9.899v2.101z"/></svg>
    </a>
  </span>

</div>
